import { createSelector } from '@reduxjs/toolkit';

import type { ReduxStateType } from 'Core/store.ts';

const productSelector = (state: ReduxStateType) => state.product;

export const productDataSelector = createSelector(productSelector, ({ data }) => data);
